
      module.exports = {
        functional: true,
        render(_h, _vm) {
          const { _c, _v, data, children = [] } = _vm;

          const {
            class: classNames,
            staticClass,
            style,
            staticStyle,
            attrs = {},
            ...rest
          } = data;

          return _c(
            'svg',
            {
              class: [classNames,staticClass],
              style: [style,staticStyle],
              attrs: Object.assign({"xmlns":"http://www.w3.org/2000/svg","viewBox":"0 0 58 58"}, attrs),
              ...rest,
            },
            children.concat([_c('g',{attrs:{"fill":"currentColor","fill-rule":"evenodd"}},[_c('circle',{attrs:{"cx":"29","cy":"29","r":"29","fill-opacity":".12"}}),_c('path',{attrs:{"d":"M21.689 14.255c-3.482 0-6.315 3.094-6.315 6.896 0 3.803 2.833 6.896 6.315 6.896s6.314-3.093 6.314-6.896c0-3.802-2.832-6.896-6.314-6.896zm14.357.987h-.043c-1.462.013-2.827.648-3.844 1.79-.999 1.121-1.542 2.6-1.53 4.165.013 1.565.58 3.035 1.597 4.14 1.025 1.112 2.383 1.723 3.828 1.723h.043c1.462-.012 2.827-.648 3.844-1.79.999-1.12 1.542-2.6 1.53-4.165-.026-3.242-2.456-5.863-5.425-5.863zm.266 12.948h-.524c-2.442 0-4.671.956-6.353 2.523a12.553 12.553 0 013.816 5.082c.554 1.349.87 2.77.944 4.234 1.512.928 3.444 1.392 5.797 1.392 2.353 0 4.286-.464 5.797-1.392v-2.08c0-5.38-4.251-9.76-9.477-9.76zM31.19 39.115a9.574 9.574 0 00-3.704-7.031 9.015 9.015 0 00-5.511-1.88h-.572c-5.1 0-9.234 4.258-9.234 9.51v1.13c3.173 1.262 6.346 1.893 9.52 1.893 3.173 0 6.346-.631 9.519-1.894v-1.128c0-.202-.006-.402-.019-.6z","fill-rule":"nonzero"}})])])
          )
        }
      }
    